module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "richard-arnold-clarke-but-procrastination-and-delay-are-my-only-portion-in-this-world."
    }
  }, [_c('h1', [_vm._v("Richard Arnold Clarke –"), _c('br'), _vm._v(" “But Procrastination and Delay Are My"), _c('br'), _vm._v(" Only Portion in this World.”")]), _vm._v(" "), _c('p', [_vm._v("Richard Arnold Clarke was the youngest of the six living children of Richard Feaver (I will refer to him as R Feaver as this is how he signed his name) and Rebecca Clarke. He was the youngest of a close knit, lively, well-educated, and loving family. Born in 1893, he had four surviving elder sisters—Dorothy (b. 1884), Edith (b.1886), Anne or Queenie (b. 1887) and Winifred (b. 1889). He also had one elder brother, Wilfrid, who was two years older than him.")]), _vm._v(" "), _c('p', [_vm._v("His sisters had all been educated at primary and secondary school and then two of them attained university degrees (not that they were awarded as women were not allowed to be awarded their degrees at this stage). Arnold and his brother were the babies of the family but shared a love of cricket and games with their sisters and photographs show happy smiles and a family who happily spent time with each other.")]), _vm._v(" "), _c('p', [_vm._v("Of all the Clarke siblings I have found Arnold’s early life the most difficult to research. The first port of call for all family research are the census records. Being born in 1893, he does not feature in the 1891 census and then I could not find him in the 1901 or 1911 census either, so I was reliant upon family documents or what little was available online.")]), _vm._v(" "), _c('p', [_vm._v("It may have been reasonable to think that because there were two living descendants (his children Richard and Christine) that there would be anecdotal evidence but Arnold never spoke of his early life to his children and so it was a matter of wringing the most information out of the slimmest pickings.")]), _vm._v(" "), _c('p', [_vm._v("Travel diaries and photos written and kept by his sisters show Arnold enjoying family holidays in the seaside resorts of Worthing and Gorleston and Herne Bay in the summers of 1899 and 1900 and 1905, respectively. He is only referred to directly once in the Worthing diary on 18 August, a Friday, "), _c('em', [_vm._v("Margaret, Winnie and Arnold had a goat chaise")]), _vm._v("—apparently there were not enough donkeys to go around.")]), _vm._v(" "), _c('p', [_vm._v("He gets two direct mentions in the Gorleston holiday diary—13 August, "), _c('em', [_vm._v("Father, Dorothy and Arnold went into Yarmouth")]), _vm._v(" and 14 August, "), _c('em', [_vm._v("Mrs Starbuck, Arnold and Leslie went by a brabe to the Lake (Fritton)")]), _vm._v(" and then he is lumped together with his siblings on 15 August, "), _c('em', [_vm._v("Father and Mother took the three youngest into Yarmouth")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("It is hardly surprising that the activities of a 7 or8-year-old boy do not feature highly or frequently in the diaries of his teenage sisters. Wilfrid is similarly ignored. However, there are a few seaside photos from Herne Bay with all the family included and the boys involved in rowing and playing on the sands.")]), _vm._v(" "), _c('p', [_vm._v("Even six years later, when Queenie, Winnie, Wilfrid and Arnold head to Scotland to spend time with Aunt Di after the death of their mother, the boys get very few mentions and when they are they always mentioned together— 24 August, "), _c('em', [_vm._v("In the afternoon the boys went for a row")]), _vm._v(" and 28 August, "), _c('em', [_vm._v("the boys bathed before breakfast")]), _vm._v(". In this later diary, though, all the activities “we” partook include “the boys” as opposed to the earlier diaries where there is a feeling that Edith, the author, would have been happy for the “youngest” to be kept away!")]), _vm._v(" "), _c('p', [_vm._v("Sorting through postcards and letters brought up little in the way of mail to or from Arnold, but one piece raised more questions than answers. A postcard with cricketer G.H Hirst on the front is addressed “Master A Clarke. c/o Miss Bennett, Steyne School, Worthing, Sussex” with a date stamp of 9 p.m., Sp 14, 03, Gravesend and a green half penny stamp. The brief message reads—"), _c('em', [_vm._v("Hope you arrived safely. I am sending you the cricketer you wished for and will try and grab some more. With much love, Winnie")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Sorry! Worthing? I had always been under the impression that he was educated in Gravesend like his sisters and brother were until they attended secondary school. Why would you send a ten-year-old to a different county to be educated? I had knowledge through creating a family tree that Aunt Harriet (Rebecca’s sister) lived in Worthing with her haberdasher husband, Robert and their nine children but it still did not really make sense that young Arnold would be sent away from home.")]), _vm._v(" "), _c('p', [_vm._v("I finally made inroads with the census by looking for Arnold Clarke not Richard Arnold Clarke and bingo, there he was in 1901 a boarder/pupil at 13 The Steyne, Worthing. So, he was there from the age of eight. He was still a baby.")]), _vm._v(" "), _c('p', [_vm._v("From the Steyne School in Worthing, Arnold (with his brother Wilfrid who had been at Gravesend Municipal Day School) went to St. Lawrence School in Ramsgate. They both started at the school in 1904. Arnold wrote to Edith soon after arriving, "), _c('em', [_vm._v("We arrived quite safely at the school and it will be alright after a week or we get into the way of the school. I am in third form and we have to learn Greek or German, would you ask mother which I have to. We have not begun football yet. We can see the seniors played easily and can talk to them but are not allowed to speak. We went to our own little chapel this morning for church. Arnold")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("There is a handful of postcards send to and from Wilfrid and Arnold to their sisters. They are often of cricketers as a passion for cricket was something that all siblings shared and they enjoyed hunting out certain cricketers to send to each other whilst also keeping up with each other’s news. Queenie seems to have been the best at writing and keeps her brothers updated with her studies at Cambridge.")]), _vm._v(" "), _c('p', [_vm._v("Wilfrid left Ramsgate in 1908 and Arnold in 1909. Wilfrid went straight to Vickers in Erith on an engineering apprenticeship and Arnold went all the way to Glasgow to a shipping firm called Yarrow and Sons. Arnold also commenced an apprenticeship as an engineer.")]), _vm._v(" "), _c('p', [_vm._v("To understand why Arnold might have gone as far away as Glasgow, one needs to understand a bit about the family history. Arnold’s rich Aunt Dinah (his mother, Rebecca’s, eldest sister) was the widow of Sir William Pearce, 1st Baronet. Dinah and William married in Gillingham, near to Gravesend and after supervising the building of HMS “Achilles” (the first ironclad warship) in Chatham, William moved to Glasgow to become a partner in a shipping firm before eventually becoming the sole owner of Fairfield Shipping and Engineering Company.")]), _vm._v(" "), _c('p', [_vm._v("He became an incredibly wealthy man and had many family members employed in his business, including one of his brother-in-law’s, Dinah’s sister Ann’s husband. Even though Sir William had been dead a long time when Arnold moved up there, many family members, both close and distant, remained in the area and Dinah visited frequently having property in Scotland. With all these connections it is not surprising that Arnold was able to find work up there.")]), _vm._v(" "), _c('p', [_vm._v("The first indication we have of Arnold living in Glasgow is a mention made in one of Edith’s travel diaries from 1909. Edith had travelled to Glasgow to meet with Aunt Di for a motor trip through the Lakes District. Before setting off, she spent a few days in Glasgow with her aunt meeting with family members.")]), _vm._v(" "), _c('p', [_vm._v("She writes on 20 September 1909, "), _c('em', [_vm._v("Very soon after Arnold came in and stayed to dinner and I thought already he seemed older in his ways. We had a very nice, if somewhat short chat, until he had to leave.")]), _vm._v(" It is hard to know when Edith had last seen Arnold, but one imagines that he would have returned to Gravesend after leaving St Lawrence’s after the school year had concluded, so she had probably seen him quite recently.")]), _vm._v(" "), _c('p', [_vm._v("She catches up with him again on the 22, "), _c('em', [_vm._v("I stayed and chatted until it was time for me to go to Scotsburn (sic) (probably means Scotstoun). Arnold was not in when I arrived but he and Lennie Shute soon came up. What a difference there was between the two. Arnold so tall and broad, Lennie so very small in height and breadth. We had tea downstairs as A"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("’")]), _vm._v("s table would have been too small for two. We then wandered down towards the river and I saw Farrow"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("’")]), _vm._v("s (sic")]), _vm._v("—"), _c('em', [_vm._v("probably means Yarrow’s) works from")]), _vm._v("—"), _c('em', [_vm._v("side but it was too late to go over them.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("We then set off for the Pearce Institute. A introduced me to the Glasgow tribe which is rather extraordinary after the London ones. We found Auntie and Miss Prescott at the club and we all went down to the hall for music and singing concert by the girls of the club of WCA and to hear an address. Left soon after 9 o"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("’")]), _vm._v("clock, we to motor home to the hotel, A to wander back to his lodgings.")])]), _vm._v(" "), _c('p', [_vm._v("Three days later she sends a postcard to Queenie to update her on Arnold—"), _c('em', [_vm._v("I went to tea with the Shute’s and then onto A"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("’")]), _vm._v("s for another. His house is a dear wee one and his landlady very nice I should imagine but only judging from her sister. I saw Yarrows buildings and the shop where A works, but it was absolutely dark. He wants some larger waistcoats (I am bringing two home), some kid gloves to hide his hands on a Sunday and a third thing I have forgotten but will substitute on my own")]), _vm._v("—"), _c('em', [_vm._v("letters.")])]), _vm._v(" "), _c('p', [_vm._v("After this, Arnold falls off the records until January 1911 when a letter is sent from him to Queenie. It is a light-hearted letter full of inside jokes which makes it quite difficult to understand but the sentiment and the affection between siblings is clear. As are Arnold’s sketching skills which we are introduced to for the first time.")]), _vm._v(" "), _c('p', [_vm._v("The confusing thing about this letter is the address on the top of the first page. There are no records of Arnold visiting Lincoln and, to my knowledge, no one of any significance in Lincoln to visit. The postmark on the front of the envelope, however, is for Scotstoun, where he lived in Glasgow so maybe it was a part of the inside joke—hard to know.")]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "start-of-ww1"
    }
  }, [_c('h3', [_vm._v("Start Of WW1")]), _vm._v(" "), _c('p', [_vm._v("After this there is no remaining communication between Arnold and the rest of the family until 1914. A reference in Wilfrid’s obituary refers to Wilfrid and Arnold signing up for duty for WW1, unbeknownst to each other, on the same day. Arnold’s Admiralty records have this day as the 5 September 1914, 39 days after the war started.")]), _vm._v(" "), _c('p', [_vm._v("His address is given as Whiteinch, Glasgow and family anecdotes have him still working at Yarrow’s engineering at this point but upon enrolling he went into training and admiralty records have him stationed firstly at HMS Pembroke 1. HMS Pembroke was a shore-based training facility in Chatham, not far from the family home in Gravesend.")]), _vm._v(" "), _c('p', [_vm._v("It was a facility used to train engineers and engine room artificers— “As warships became more complex the Navy had to introduce training courses especially for engineers and artificers. Also, stokers serving the boilers in the engine rooms and this ‘school’ was one of the first buildings to appear on St. Mary’s Island beside Number 2 basin.”"), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("St. Mary’s Island was a part of the Chatham Dockyards and was a part of the shore facility Arnold trained at. December 1914 saw him return to Scotland but this time he was in Edinburgh at another training facility—Granton.")]), _vm._v(" "), _c('p', [_vm._v("Referred to as Columbine in his official documents, the training base near Edinburgh was in the harbour at Granton where trawlers and yachts, used for patrol work and minesweeping, were based. This was training in the very work Arnold would be involved in once he went to sea in April 1915. The one surviving letter, written 22 January 1915 and a postcard from 26 December 1914 are the only personal recollections of this time.")]), _vm._v(" "), _c('p', [_vm._v("The postcard has Arnold on the front with two unnamed, uniformed men and is sent to Queenie and he writes, "), _c('em', [_vm._v("This wasn’t faked. It was pouring hard and we just walked into the shop and had them taken")]), _vm._v(". It is our first view of Arnold in his RNVR uniform, if hidden under a large coat.")]), _vm._v(" "), _c('p', [_vm._v("The letter gives the impression he did not particularly enjoy his time in Granton—"), _c('em', [_vm._v("Ever since getting my so called hook my luck has deserted me and I wish I had never seen Granton and I shall be heartily glad when I can safely put E.R.A RN after my name, but procrastination and delay are my only portion in this world and a brain running to seed")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("This sense of impatience speaks of a man ready to get to move on from training and get to work however there were three more months of training, most of them done back in London at HMS Pembroke II before Arnold signed on to duty at the Royal Docks on "), _c('em', [_vm._v("HMS India")]), _vm._v(" on 13 August 1915.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.12708in",
      "height": "2.40417in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold and Wilfred approximately 1904")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.19092in",
      "height": "2.78941in"
    },
    attrs: {
      "alt": "",
      "src": "media/file2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold and Winnie with mother approximately 1903/4")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.64149in",
      "height": "2.4312in"
    },
    attrs: {
      "alt": "",
      "src": "media/file3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold and Wilfred as babies, 1894")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.63953in",
      "height": "2.68293in"
    },
    attrs: {
      "alt": "",
      "src": "media/file4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Family holiday in Herne Bay, 1905. Queenie, Father,"), _c('br'), _vm._v("\nWinnie and Arnold’s foot")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.58068in",
      "height": "2.81465in"
    },
    attrs: {
      "alt": "",
      "src": "media/file5.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A group of people posing for the camera Description automatically generated with medium confidence")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold, Winnie, and Wilfred. I do not think Winnie is happy with"), _c('br'), _vm._v("\nthe way Arnold is holding the cat!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.61966in",
      "height": "3.34375in"
    },
    attrs: {
      "alt": "",
      "src": "media/file6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Taken on the tennis court at Daneholme. Arnold, Winnie, and Queenie seated"), _c('br'), _vm._v("\non the ground. Aunt Harriet, Father, and Uncle Robert")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.69328in",
      "height": "2.85972in"
    },
    attrs: {
      "alt": "",
      "src": "media/file7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("From left Wilfrid, Arnold, Rebecca, a friend, and Winnie at the back of 21"), _c('br'), _vm._v("\nHigh Street——the pharmacy and home until 1906.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.11925in",
      "height": "3.24167in"
    },
    attrs: {
      "alt": "",
      "src": "media/file8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold and Nurse at Daneholme.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.00886in",
      "height": "2.79792in"
    },
    attrs: {
      "alt": "",
      "src": "media/file9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("A formal photo of Lady Dinah Pearce or Aunt Di as she was known to the Clarke children. Rebecca’s stepsister who was older than her by fifteen years.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.26615in",
      "height": "2.92708in"
    },
    attrs: {
      "alt": "",
      "src": "media/file10.jpg"
    }
  })]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Arnold back row right with hockey team at St Lawrence School, Ramsgate")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.77227in",
      "height": "2.59236in"
    },
    attrs: {
      "alt": "",
      "src": "media/file11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.67492in",
      "height": "4.15164in"
    },
    attrs: {
      "alt": "",
      "src": "media/file12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Post card sent to Arnold at Steyne School, Worthing")])]), _vm._v(" "), _c('p', [_c('em', [_c('br')])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.6038in",
      "height": "2.95417in"
    },
    attrs: {
      "alt": "",
      "src": "media/file13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Daneholme, Pelham Road, Gravesend. The family moved after mother"), _c('br'), _vm._v("\ndied in 1906.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.57639in",
      "height": "2.79428in"
    },
    attrs: {
      "alt": "",
      "src": "media/file14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Father reading (unsure as to where this was taken)")])]), _vm._v(" "), _c('p', [_c('em', [_c('br')])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.69874in",
      "height": "3.03245in"
    },
    attrs: {
      "alt": "",
      "src": "media/file15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Photo from the Herne Bay Holiday in 1905.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.88274in",
      "height": "3.0907in"
    },
    attrs: {
      "alt": "",
      "src": "media/file16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("The black edged mourning card issued by the family after the untimely death of Rebecca in 1906.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3in",
      "height": "2.71389in"
    },
    attrs: {
      "alt": "",
      "src": "media/file17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Father asleep in a chair—a male Clarke family trait that"), _c('br'), _vm._v("\ncontinues to this day!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.70049in",
      "height": "3.38743in"
    },
    attrs: {
      "alt": "",
      "src": "media/file18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Winnie, Father, maybe Dorothy, and Wilfrid at Daneholme")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.35588in",
      "height": "3.33333in"
    },
    attrs: {
      "alt": "",
      "src": "media/file19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Rebecca Clarke née Sowter")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.375in",
      "height": "3.30032in"
    },
    attrs: {
      "alt": "",
      "src": "media/file20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Winifred Sowter Clarke")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "1",
      "src": "media/1.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Postcard sent to Arnold at Steyne School, Worthing")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.77022in",
      "height": "4.05911in"
    },
    attrs: {
      "alt": "",
      "src": "media/file22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Family photo without Dorothy taken whilst on holiday in Herne Bay in 1905. I love the caption— “The sulks”. Wilfrid is struggling to stay looking sulky.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.70901in",
      "height": "2.84375in"
    },
    attrs: {
      "alt": "",
      "src": "media/file23.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("A photo of the front side of Wilfrid’s circular letter. The letters written to the family were often sent from one member to another so that 5 or 6 versions did not need to be written. Soon after moving to Erith to start his apprenticeship with Vickers Wilfrid was asked for write a circular letter for the family—he took the instructions quite literally. It is a work of Art!")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.04172in",
      "height": "3.02083in"
    },
    attrs: {
      "alt": "",
      "src": "media/file24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold in a running race at what would be St Lawrence’s, Ramsgate")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.84587in",
      "height": "2.94725in"
    },
    attrs: {
      "alt": "",
      "src": "media/file25.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("Arnold’s letter to Queenie dated 1912 (on the envelope). He is in a light-hearted and jovial mood.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.25455in",
      "height": "3.21827in"
    },
    attrs: {
      "alt": "",
      "src": "media/file26.png"
    }
  }), _c('img', {
    staticStyle: {
      "width": "2.25in",
      "height": "1.73198in"
    },
    attrs: {
      "alt": "",
      "src": "media/file27.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_vm._v("http://www.stmarysislandhistorygroup.co.uk/1914-to-1920/4587963795"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 78
// module chunks = 0